import { useAuthStore } from '@/stores/auth.store';
import { usePusherStore } from '@/stores/pusher.store';
import { attemptTokenRefresh } from '@/common/api/refresh';
import { cookies } from '@/plugins/cookies';

export const isAuthenticated = async (): Promise<boolean> => {
  const authStore = useAuthStore();
  let isUnifiedAuthHandoff = false;

  if (authStore.unifiedAuthEnabled) {
    const cookieAccess = cookies.get('accessToken');
    const cookieRefresh = cookies.get('refreshToken');

    if (
      cookieAccess &&
      cookieRefresh &&
      !localStorage.getItem('accessToken') &&
      !localStorage.getItem('refreshToken')
    ) {
      localStorage.setItem('accessToken', cookieAccess);
      localStorage.setItem('refreshToken', cookieRefresh);
      isUnifiedAuthHandoff = true;

      const cookieUser = cookies.get('user');
      if (cookieUser) {
        try {
          authStore.setUser(JSON.parse(cookieUser));
        } catch {
          // ignore malformed user cookie
        }
      }
    }
  }

  const accessToken = localStorage.getItem('accessToken');
  const refreshToken = localStorage.getItem('refreshToken');

  if (!accessToken || !refreshToken) {
    return false;
  }

  const payload = accessToken.split('.')[1];
  if (!payload) return false;

  let accessTokenDetails: { exp?: number };
  try {
    accessTokenDetails = JSON.parse(atob(payload));
  } catch {
    return false;
  }

  if (typeof accessTokenDetails.exp !== 'number') return false;

  if (accessTokenDetails.exp < Date.now() / 1000) {
    try {
      await attemptTokenRefresh();
    } catch {
      return false;
    }
  }

  if (!authStore.accessToken || !authStore.refreshToken) {
    authStore.setAccessToken(accessToken);
    authStore.setRefreshToken(refreshToken);
  }

  if (isUnifiedAuthHandoff) {
    try {
      await authStore.getUserPermissions();
    } catch {
      // permissions fetch failure should not block authentication
    }
  }

  // A session signed in elsewhere (another tab, or the auth app's cookies) reaches this tab here,
  // never through login(), so after a logout here closed the last client it needs a fresh one.
  usePusherStore().connect();

  return true;
};
